import lozad from 'lozad';
import ReactGA from 'react-ga4';

import '@fontsource/gentium-book-basic/latin-700.css'; // Weight 700.
import { MCLogger } from '@mc/web-base-utils';

const loggerType = {
  draft: ['console'],
  published: ['logrocket', 'sentry'],
};

MCLogger.initial('', {
  loggerTypes: loggerType[process.env.GATSBY_STORYBLOCK_VERSION],
});

// gatsby-browser.js
const { observe } = lozad('.lozad', {
  loaded: (el) => {
    el.classList.add('fade');
  },
});

export const onInitialClientRender = () => {
  ReactGA.initialize([{ trackingId: 'G-4WZKZS9B7V' }]);
};

export const onRouteUpdate = ({ location }) => {
  observe();
};
